import { esusApi } from "@/services/api";

export type ResumeIndicatorC2Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorC2Data {
	totalCitizens: number = 0;
	totalCitizensScore: number = 0;
	maxCitizensScore: number = 0;
	totalCitizensWithTwoYearsInPeriod: number = 0;
	totalCitizensWithTwoYearsInPeriodScore: number = 0;
	maxCitizensWithTwoYearsInPeriodScore: number = 0;
}

export async function getResumeIndicatorC2({ uf, ibgeCode, ...params }: ResumeIndicatorC2Params) {
	const response = await esusApi.get<ResumeIndicatorC2Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c2/resume`,
		params
	);
	return response.data ?? new ResumeIndicatorC2Data();
}
